import React from 'react';
import './contacts.scss'

import Exit from '../getBack/exit'

import Icon from '@iconify/react';
import instagramOutlined from '@iconify/icons-ant-design/instagram-outlined';
import bxlTelegram from '@iconify/icons-bx/bxl-telegram';

function Contacts(props) {
    return (
        <>
             <div className="fifthBlockMobile">
                 <Exit />
                    <div className="fifthBlockTextMobile">CONTACTS</div>
                    <div className="secondUnderText underSub">Contacts</div>
                    <a href="https://www.instagram.com/_yarish/" className= "contactsLinkMobile">
                        <Icon icon={instagramOutlined} className="contactsIcon"/>
                        <div className="contactsLinkText">instagram</div>
                        <div className="contactsLinkName">_yarish</div>
                    </a>
                    <a href="https://t.me/yarisheo"  className= "contactsLinkMobile secondMobile">
                        <Icon icon={bxlTelegram}  className="contactsIcon"/>
                        <div className="contactsLinkText secondLink">telegram</div>
                        <div className="contactsLinkName secondName">yarisheo</div>
                    </a>
                    {/* <a href="https://www.instagram.com/_yarish/" className={showFifth? "contactsLink third" : "none"}>
                        <Icon icon={githubFilled}  className="contactsIcon"/>
                        <div className="contactsLinkText thirdLink">gitHub</div>
                        <div className="contactsLinkName">yarishb</div>
                    </a> */}
                </div>
        </>
    );
}

export default Contacts;